import React from 'react';
import { useAuth } from '../../hooks/useAuth.jsx';
import AdminDashboard from './AdminDashboard';
import StudentDashboard from './StudentDashboard';
import { CircularProgress, Box } from '@mui/material';

const Dashboard = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Router selon le rôle
  if (user?.role === 'admin') {
    return <AdminDashboard />;
  } else {
    return <StudentDashboard />;
  }
};

export default Dashboard;
